import { MessageCircle, Star, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { PRODUCTS, WHATSAPP_URL } from "../../data/promill";

const BadgeColor = (badge) => {
    const map = {
        Bestseller: "bg-pm-orange text-white",
        "High Protein": "bg-pm-green text-pm-yellow",
        Vegan: "bg-pm-greenBright text-white",
        Keto: "bg-pm-black text-pm-yellow",
        "Pre-Workout": "bg-pm-yellow text-pm-black",
        "Post-Workout": "bg-pm-yellow text-pm-black",
        "High Fiber": "bg-pm-greenBright text-white",
        Clean: "bg-white text-pm-green border border-pm-green/30",
    };
    return map[badge] || "bg-pm-black text-pm-yellow";
};

const enquireUrl = (name) =>
    `https://wa.me/919517717917?text=${encodeURIComponent(`Hi ProMill, I'd like to enquire about "${name}".`)}`;

export const ProductCard = ({ product }) => {
    const p = product;
    return (
        <article
            data-testid={`product-card-${p.id}`}
            className="group bg-white border border-pm-black/8 rounded-2xl overflow-hidden card-lift shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_18px_40px_rgb(0,0,0,0.08)] hover:border-pm-yellow"
        >
            <div className="relative h-52 overflow-hidden bg-pm-sand">
                <img
                    src={p.image}
                    alt={p.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                />
                <div className="absolute top-3 left-3 flex flex-col gap-1.5">
                    {p.badges.map((b) => (
                        <span key={b} className={`text-[10px] font-bold uppercase tracking-widest px-2.5 py-1 rounded-full ${BadgeColor(b)}`}>
                            {b}
                        </span>
                    ))}
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1 bg-white px-2.5 py-1 rounded-full border border-pm-black/10">
                    <Star className="w-3.5 h-3.5 fill-pm-yellow text-pm-yellow" />
                    <span className="text-xs font-bold">4.8</span>
                </div>
            </div>

            <div className="p-5">
                <h3 className="text-lg md:text-xl font-extrabold text-pm-black leading-tight">{p.name}</h3>
                <p className="mt-1 text-sm text-pm-black/60">{p.tagline}</p>

                <div className="mt-4 flex gap-3">
                    <div className="flex-1 rounded-lg bg-pm-sand/60 border border-pm-black/5 px-3 py-2">
                        <div className="text-[10px] uppercase tracking-widest text-pm-black/55">Protein</div>
                        <div className="text-base font-bold text-pm-green">{p.protein}g</div>
                    </div>
                    <div className="flex-1 rounded-lg bg-pm-sand/60 border border-pm-black/5 px-3 py-2">
                        <div className="text-[10px] uppercase tracking-widest text-pm-black/55">Kcal</div>
                        <div className="text-base font-bold text-pm-green">{p.kcal}</div>
                    </div>
                </div>

                <a
                    href={enquireUrl(p.name)}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`enquire-${p.id}`}
                    className="hidden"
                >
                    <MessageCircle className="w-4 h-4" />
                    Enquire Now
                </a>
            </div>
        </article>
    );
};

export const FeaturedProducts = () => {
    const items = PRODUCTS.slice(0, 6);
    return (
        <section
            id="menu"
            data-testid="featured-products-section"
            className="relative bg-pm-cream py-20 md:py-24"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
                    <div>
                        <span className="inline-block text-pm-orange font-bold tracking-[0.25em] uppercase text-[11px] mb-3">
                            Featured
                        </span>
                        <h2 className="text-4xl md:text-5xl font-extrabold tracking-[-0.02em] text-pm-black leading-tight">
                            Popular Picks
                        </h2>
                        <p className="mt-3 text-pm-black/60">Curated favorites. Loved by thousands.</p>
                    </div>
                    <Link to="/menu" data-testid="view-full-menu-link" className="inline-flex items-center gap-2 text-pm-green font-bold hover:gap-3 transition-all">
                        View Full Menu <ArrowRight className="w-4 h-4" />
                    </Link>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {items.map((p) => (
                        <ProductCard key={p.id} product={p} />
                    ))}
                </div>
            </div>
        </section>
    );
};
